import { apiRequest } from "../util/apiUtils";

export const wishList = async (params) => {
  try {
    const res = await apiRequest("get", `wishlist/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const wishListManage = async (payload) => {
  try {
    const res = await apiRequest("post", `wishlist/manage`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
